import { Home, Star, Gamepad2, Heart, Lightbulb } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const ICONS: Record<string, React.ComponentType<{ className?: string; fill?: string; style?: React.CSSProperties }>> = {
  today:      Home,
  insights:   Lightbulb,
  milestones: Star,
  activities: Gamepad2,
  health:     Heart,
};

const TABS = [
  { id: 'today',      label: 'Today',      path: '/' },
  { id: 'insights',   label: 'Knowledge',  path: '/insights' },
  { id: 'milestones', label: 'Milestones', path: '/milestones' },
  { id: 'activities', label: 'Activities', path: '/activities' },
  { id: 'health',     label: 'Health',     path: '/health' },
];

const BottomNavigation = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const activeId =
    pathname === '/'             ? 'today'
    : pathname === '/insights'   ? 'insights'
    : pathname === '/milestones' ? 'milestones'
    : pathname === '/activities' ? 'activities'
    : pathname === '/health'     ? 'health'
    : 'today';

  return (
    <nav className="bottom-nav lg:hidden">
      <div className="flex items-stretch justify-around px-1">
        {TABS.map(({ id, label, path }) => {
          const active = activeId === id;
          const Icon = ICONS[id];

          return (
            <button
              key={id}
              onClick={() => navigate(path)}
              className="flex flex-col items-center justify-center gap-0.5 min-w-[50px] min-h-[48px] py-2 flex-1 relative"
            >
              {/* Active indicator bar */}
              <span
                className="absolute top-0 left-1/2 -translate-x-1/2 rounded-full transition-all duration-200"
                style={{
                  width: active ? 20 : 0,
                  height: 2,
                  background: active ? 'hsl(var(--primary))' : 'transparent',
                }}
              />

              {/* Icon wrapper — Health tab gets notification badge slot */}
              <span className="relative flex items-center justify-center w-6 h-6">
                <Icon
                  className="w-6 h-6"
                  style={{ color: active ? 'hsl(var(--nav-active))' : 'hsl(var(--nav-inactive))' }}
                  fill={active ? 'currentColor' : 'none'}
                />
                {/* Health notification badge */}
                {id === 'health' && (
                  <span
                    className="absolute top-0 right-0 rounded-full"
                    style={{
                      width: 7,
                      height: 7,
                      background: 'hsl(var(--destructive))',
                      border: '2px solid white',
                      display: 'none', // toggle via JS/state when there are pending health items
                    }}
                  />
                )}
              </span>

              {/* Label */}
              <span
                style={{
                  fontSize: 12,
                  fontWeight: active ? 600 : 500,
                  lineHeight: '16px',
                  color: active ? 'hsl(var(--nav-active))' : 'hsl(var(--nav-inactive))' ,
                }}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;
